export type GanglionConversationResponse = GanglionConversationStatusResponse | GanglionConversationMessageResponse | GanglionConversationStateResponse | GanglionCatchupResponse;

export type GanglionConversationStatusResponse = {
    type: "status";
    authenticated: boolean;
}

export type GanglionCatchupResponse = {
    type: "catchup";
    conversationId?: string;
    messages: GanglionCatchupMessage[];
}

export type GanglionCatchupMessage = {
    id?: number;            // per-conversation index (the catchup cursor unit)
    fromUser?: boolean;
    message?: string;
    model?: string;
    contentType?: string;
}

export type GanglionConversationStateResponse = {
    type: "conversation-state";

    conversationId?: string;
    subject?: string;
}

export type GanglionConversationMessageResponse = {
    type: "message" | "message-start" | "message-end" | "delta" | "stall" | "user-message"; // "msg-ack"

    conversationId?: string;
    contentType?: string;
    userId?: string;
    message?: string;
    reasoning?: string;
    textDelta?: string;
    reasoningDelta?: string;
    model?: string;
    subject?: string;
    data?: any;
    sequence?: number;
    toolCall?: string;
    toolArguments?: { [id: string]: string };

    action?: string;
    component?: string;
    receivedTime?: string;
}

export function isGanglionMessage(
    resp: GanglionConversationResponse | unknown
): resp is GanglionConversationMessageResponse | GanglionConversationStateResponse {
    if (!resp || typeof resp !== "object") return false;
    const t = (resp as any).type;
    return t === "message" || t === "message-start" || t === "message-end" || t === "delta" || t == "conversation-state" || t == "stall" || t == "user-message";
}

